import {
  Button,
  CustomInput,
  Dropdown,
  DropdownMenu,
  Icon,
  Label,
  UncontrolledTooltip,
} from '@polichat/flamboyant';
import { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { DropdownToggle } from 'reactstrap';

import Animation from 'src/components/common/animation';
import { CustomerContactCreditContext } from 'src/context/CustomerContactCredit/context';

import { useSelector } from 'react-redux';
import {
  getMonthAndNextMont,
  separateCreditsByType,
  updateCredits,
} from './helpers';

import { Controller } from 'react-hook-form';
import history from 'src/services/history';
import { Credits } from './helpers/types';
import './index.css';
import { useLocalForm } from './useLocalForm';

interface MonthDate {
  month: string;
  nextMonth: string;
}

export function ContactCredits() {
  const ADM_MANAGER_ROLES = ['adm', 'manager'];

  const [date, setDate] = useState<MonthDate>();
  const [credits, setCredits] = useState<Credits>();
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);
  const [selectedChannel, setSelectedChannel] = useState<any>();

  const form = useLocalForm();
  const selectedItem = form.watchedValue.credit_id;

  const channels_settings = useSelector(
    //@ts-ignore
    (state) => state?.general?.user?.channels
  );
  const userIsAdminOrManager = useSelector((state) => {
    //@ts-ignore
    let userRole = state?.general?.user?.superRole;
    if (!userRole) return false;
    return ADM_MANAGER_ROLES.indexOf(userRole) >= 0;
  });
  const isWl = useSelector(
    //@ts-ignore
    (state) => state?.whitelabel?.config?.is_white_label
  );

  const context = useContext(CustomerContactCreditContext);

  function handleClickOnDropDown() {
    if (!isOpenDropdown) {
      context.refresh();
    }
  }

  function handleBuyCredits() {
    handleToggleDropdown();
    history.push({
      pathname: '/tools/credit',
    });
  }

  const handleToggleDropdown = useCallback(() => {
    setIsOpenDropdown((prev) => !prev);
  }, []);

  useEffect(() => {
    if (!date) {
      setDate(getMonthAndNextMont());
    }
  }, []);

  useEffect(() => {
    if (
      context.data &&
      Object.keys(context.data).length &&
      channels_settings?.length
    ) {
      if (!credits) {
        setCredits(separateCreditsByType(context.data, channels_settings));
      } else {
        setCredits((current) => updateCredits(context.data, current));
      }
    }
  }, [context.data, setCredits]);

  useEffect(() => {
    if (!credits) return;

    // setar pela primeira vez
    if (selectedItem === '') {
      const channel = credits.newBillingModel
        ? { ...credits.channels[0], id: 'detached' }
        : credits?.wabaGroups[0];

      if (channel) {
        form.setValue('channel_credit_id', `${channel.id}`);
        setSelectedChannel(channel);
      }
    } else {
      // atualiza item selecionado
      if (selectedItem === 'detached') {
        setSelectedChannel(credits?.detached);
        return;
      }

      if (!!Number(selectedItem) && credits?.regular.length != 0) {
        setSelectedChannel(
          credits?.regular.find(
            (channel) => Number(channel.id) === Number(selectedItem)
          )
        );
      } else {
        const channelData = credits.newBillingModel
          ? credits.channels.find((channel) => channel.id === Number(selectedItem))
          : credits?.wabaGroups.find((channel) => channel.id === selectedItem);

        setSelectedChannel(channelData);
      }
    }
  }, [credits, selectedItem, channels_settings]);

  // if (credits?.newBillingModel) {
  //   return (
  //     <>
  //       <Fragment>
  //         <Dropdown
  //           isOpen={isOpenDropdown}
  //           toggle={handleToggleDropdown}
  //           className="visitorsNotification"
  //           color={'neutral'}
  //           disabled={context.loading}
  //         >
  //           <DropdownToggle
  //             color={'neutral'}
  //             border="border-none"
  //             id="tooltipContactCreditsNew"
  //             caret
  //             onClick={handleClickOnDropDown}
  //           >
  //             {context.loading && !selectedItem ? (
  //               <div className="credits_loading">
  //                 <span>Carregando</span>
  //                 <Animation icon="loading" size={14} />
  //               </div>
  //             ) : (
  //               <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
  //                 <div>
  //                   <span
  //                     className="credits_selected_title"
  //                     style={{ fontSize: '14px', fontWeight: '700', lineHeight: '16.8px' }}
  //                   >
  //                   {selectedChannel?.name}
  //                 </span>
  //                 </div>
  //                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
  //                   <i
  //                     className={
  //                       selectedChannel?.icon?.name
  //                         ? selectedChannel?.icon?.name
  //                         : 'poli-icon pi-whatsapp-fill'
  //                     }
  //                     style={{
  //                       fontSize: '16px',
  //                       color: selectedChannel?.icon?.color ? selectedChannel?.icon?.color : 'var(--primary)',
  //                       margin: '0'
  //                     }}
  //                   />
  //                   <span style={{ fontWeight: '500', fontSize: '14px', lineHeight: '16px' }}>{'Consumo: '}</span>
  //                   <span
  //                     className={`credits_value ${
  //                       selectedChannel?.color
  //                         ? `credits_value_${selectedChannel?.color}`
  //                         : ''
  //                     }`}
  //                   >
  //                     {selectedChannel?.used}
  //                   </span>
  //                   {selectedChannel?.total !== undefined ? `/${selectedChannel.total}` : ''}
  //                   <i
  //                     className={`poli-icon ${isOpenDropdown ? 'pi-simple-arrow-up-line' : 'pi-simple-arrow-down-line'}`}
  //                     style={{ fontSize: '16px', color: 'var(--primary)', margin: '0' }}
  //                   />
  //                 </div>
  //               </div>
  //             )}
  //           </DropdownToggle>
  //           <DropdownMenu className={`plateBox${isWl ? 'Wl' : ''}`} style={{ width: isWl ? '300px' : '232px' }}>
  //             {/* Header */}
  //             <div className="selectorVisitorBoxHeader plateBoxHeader">
  //               <p
  //                 className="credits_menu_title"
  //                 style={{
  //                   fontSize: '16px',
  //                   width: '-webkit-fill-available',
  //                   margin: '0px 0px 10px 0px !important',
  //                   lineHeight: '22px',
  //                 }}
  //               >
  //                 Canais WhatsApp
  //               </p>
  //             </div>
  //             {/* Itens */}
  //             <div className="selectorVisitorBoxBody plateBoxBodyNew" style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0 }}>
  //               {context.loading && (
  //                 <div className="credits_loading">
  //                   <span>Carregando</span>
  //                   <Animation icon="loading" size={14} />
  //                 </div>
  //               )}
  //
  //               <ul>
  //                 {/*grupos waba*/}
  //                 {!context.loading && credits?.channels.length != 0 && (
  //                   <Fragment>
  //                     <Controller
  //                       control={form.control}
  //                       name="channel_credit_id"
  //                       render={({ field }) => (
  //                         <Fragment>
  //                           {credits?.channels?.map((channel) => (
  //                             <li
  //                               key={`${channel.id}`}
  //                               className="credits_waba_container"
  //                             >
  //                               <div className="credits_selected_container">
  //                                 <div className="credits_channel_info">
  //                                   <CustomInput
  //                                     type="radio"
  //                                     id={`${channel.id}`}
  //                                     value={channel.id}
  //                                     onChange={field.onChange}
  //                                     checked={field.value === String(channel.id)}
  //                                   />
  //                                   <i
  //                                     className={'poli-icon pi-whatsapp-api-fill'}
  //                                     style={{ fontSize: '22px', color: 'var(--whatsapp-color)', margin: '0' }}
  //                                   />
  //                                   <Label for={`${channel.id}`}>
  //                                     {channel.name}
  //                                   </Label>
  //                                 </div>
  //
  //                                 <div className="credits_selected">
  //                                   <span style={{
  //                                     fontSize: '13px',
  //                                     lineHeight: '15px',
  //                                     fontWeight: '500',
  //                                   }}>{'Crédito Ativos: '}</span>
  //                                   <span style={{
  //                                     fontSize: '16px',
  //                                     lineHeight: '16px',
  //                                     fontWeight: '600',
  //                                   }}>{channel.active}</span>
  //                                 </div>
  //                                 <div className="credits_selected" style={{ marginTop: '3px' }}>
  //                                   <span style={{
  //                                     fontSize: '13px',
  //                                     lineHeight: '15px',
  //                                     fontWeight: '500',
  //                                   }}>{'Crédito Receptivos: '}</span>
  //                                   <span style={{
  //                                     fontSize: '16px',
  //                                     lineHeight: '16px',
  //                                     fontWeight: '600',
  //                                   }}>{channel.receptive}</span>
  //                                 </div>
  //                               </div>
  //                             </li>
  //                           ))}
  //                         </Fragment>
  //                       )}
  //                     />
  //                   </Fragment>
  //                 )}
  //               </ul>
  //             </div>
  //
  //             {userIsAdminOrManager && !isWl && (
  //               <div className="credits_footer">
  //                 <Button width="total" color="primary" onClick={handleBuyCredits}>
  //                   Comprar crédito
  //                 </Button>
  //               </div>
  //             )}
  //
  //           </DropdownMenu>
  //         </Dropdown>
  //       </Fragment>
  //     </>
  //   );
  // }

  // return (
  //   <Fragment>
  //     <Dropdown
  //       isOpen={isOpenDropdown}
  //       toggle={handleToggleDropdown}
  //       className="visitorsNotification"
  //       color={'neutral'}
  //       disabled={context.loading}
  //     >
  //       <DropdownToggle
  //         color={'neutral'}
  //         border="border-none"
  //         id="tooltipContactCredits"
  //         caret
  //         onClick={handleClickOnDropDown}
  //       >
  //         <UncontrolledTooltip
  //           placement="bottom"
  //           target="tooltipContactCredits"
  //         >
  //           Saldo de Créditos para consumo no mês.
  //         </UncontrolledTooltip>
  //
  //         {context.loading && !selectedItem ? (
  //           <div className="credits_loading">
  //             <span>Carregando</span>
  //             <Animation icon="loading" size={14} />
  //           </div>
  //         ) : (
  //           <div className="credits_selected_container">
  //             <Icon
  //               icon={
  //                 selectedChannel?.icon?.name
  //                   ? selectedChannel?.icon?.name
  //                   : 'poli-icon pi-whatsapp-fill'
  //               }
  //               size={22}
  //               color={
  //                 selectedChannel?.icon?.color
  //                   ? selectedChannel?.icon?.color
  //                   : 'var(--primary)'
  //               }
  //             />
  //             <div className="credits_selected">
  //               <span className="credits_selected_title">
  //                 {selectedChannel?.name}
  //               </span>
  //               <p className="credits_selected_values">
  //                 <span
  //                   className={`credits_value ${
  //                     selectedChannel?.color
  //                       ? `credits_value_${selectedChannel?.color}`
  //                       : ''
  //                   }`}
  //                 >
  //                   {selectedChannel?.used}
  //                 </span>
  //                 /<span>{selectedChannel?.total}</span> Créditos
  //               </p>
  //             </div>
  //             <Icon icon="poli-icon pi-simple-arrow-down-line" />
  //           </div>
  //         )}
  //       </DropdownToggle>
  //       <DropdownMenu className={`plateBox${isWl ? 'Wl' : ''}`} style={{ width: isWl ? '300px' : '232px' }}>
  //         {/* Header */}
  //         <div className="selectorVisitorBoxHeader plateBoxHeader">
  //           <p
  //             className="plateBoxName credits_menu_title"
  //             style={{
  //               fontSize: '1.2rem',
  //               width: '-webkit-fill-available',
  //               margin: '0px 0px 10px 0px !important',
  //             }}
  //           >
  //             Créditos
  //           </p>
  //           <p
  //             className="plateBoxUpLine credits_menu_date"
  //             style={{
  //               display: 'flex',
  //               flexDirection: 'column',
  //               alignItems: 'flex-end',
  //               width: '-webkit-fill-available',
  //               margin: '0',
  //             }}
  //           >
  //             <span>{date?.month ?? ''}</span>
  //             <br />
  //             <span style={{ fontSize: '0.7rem', textAlign: 'right' }}>
  //               Créditos serão renovados em 01/
  //               {date?.nextMonth ?? ''}
  //             </span>
  //           </p>
  //         </div>
  //         {/* Itens */}
  //         <div className="selectorVisitorBoxBody plateBoxBody">
  //           {context.loading && (
  //             <div className="credits_loading">
  //               <span>Carregando</span>
  //               <Animation icon="loading" size={14} />
  //             </div>
  //           )}
  //
  //           <ul>
  //             {/* grupos waba */}
  //             {!context.loading && credits?.wabaGroups.length != 0 && (
  //               <Fragment>
  //                 <Controller
  //                   control={form.control}
  //                   name="channel_credit_id"
  //                   render={({ field }) => (
  //                     <Fragment>
  //                       {credits?.wabaGroups?.map((wabagroup) => (
  //                         <li
  //                           key={`${wabagroup.id}`}
  //                           className="credits_waba_container"
  //                         >
  //                           <div className="credits_selected_container">
  //                             <div className="credits_channel_info">
  //                               <CustomInput
  //                                 type="radio"
  //                                 id={`${wabagroup.id}`}
  //                                 value={wabagroup.id}
  //                                 onChange={field.onChange}
  //                                 checked={field.value === String(wabagroup.id)}
  //                               />
  //                               <Icon
  //                                 size={25}
  //                                 icon={'poli-icon pi-whatsapp-business-fill'}
  //                                 color={'var(--whatsapp-color)'}
  //                               />
  //                               <Label for={`${wabagroup.id}`}>
  //                                 Conta WABA
  //                               </Label>
  //                             </div>
  //
  //                             <div className="credits_selected">
  //                               <span>Saldo</span>
  //                               <p className="credits_selected_values">
  //                                 <span
  //                                   className={`credits_value ${
  //                                     wabagroup?.color
  //                                       ? `credits_value_${wabagroup?.color}`
  //                                       : ''
  //                                   }`}
  //                                 >
  //                                   {wabagroup.used}
  //                                 </span>
  //                                 {'/'}
  //                                 <span>{wabagroup.total}</span>
  //                               </p>
  //                             </div>
  //                           </div>
  //                           <ul className="credits_waba_channels">
  //                             {wabagroup.channels?.map((wabachannel) => (
  //                               <li key={wabachannel.id}>
  //                                 <span>{wabachannel.name}</span>
  //                                 <p className="credits_selected_values">
  //                                   Consumo:{' '}
  //                                   <span
  //                                     className={`credits_value ${
  //                                       wabagroup?.color
  //                                         ? `credits_value_${wabagroup?.color}`
  //                                         : ''
  //                                     }`}
  //                                   >
  //                                     {wabachannel.used}
  //                                   </span>
  //                                 </p>
  //                               </li>
  //                             ))}
  //                           </ul>
  //                         </li>
  //                       ))}
  //                     </Fragment>
  //                   )}
  //                 />
  //               </Fragment>
  //             )}
  //
  //             {/* canais gerais */}
  //             {!context.loading && credits?.regular?.length != 0 && !isWl && (
  //               <Fragment>
  //                 <Controller
  //                   control={form.control}
  //                   name="channel_credit_id"
  //                   render={({ field }) => (
  //                     <Fragment>
  //                       {credits?.regular?.map((channel) => (
  //                         <li
  //                           className="credits_selected_container"
  //                           key={`${channel.id}`}
  //                         >
  //                           <div className="credits_channel_info">
  //                             <CustomInput
  //                               type="radio"
  //                               id={`regular-${channel.id}`}
  //                               onChange={field.onChange}
  //                               value={channel.id}
  //                               checked={field.value === String(channel.id)}
  //                             />
  //                             <Icon
  //                               size={25}
  //                               icon={'poli-icon pi-whatsapp-fill'}
  //                               color={'var(--whatsapp-color)'}
  //                             />
  //                             <Label for={`regular-${channel.id}`}>
  //                               {channel.name}
  //                             </Label>
  //                           </div>
  //                           <div className="credits_selected">
  //                             <span>Saldo</span>
  //                             <p className="credits_selected_values">
  //                               <span
  //                                 className={`credits_value ${
  //                                   channel?.color
  //                                     ? `credits_value_${channel?.color}`
  //                                     : ''
  //                                 }`}
  //                               >
  //                                 {channel.used}
  //                               </span>
  //                               {'/'}
  //                               <span>{channel.total}</span>
  //                             </p>
  //                           </div>
  //                         </li>
  //                       ))}
  //                     </Fragment>
  //                   )}
  //                 />
  //               </Fragment>
  //             )}
  //
  //             {/* creditos avulsos */}
  //             {!context.loading && credits?.detached && (
  //               <Fragment>
  //                 <Controller
  //                   control={form.control}
  //                   name="channel_credit_id"
  //                   render={({ field }) => (
  //                     <Fragment>
  //                       <li
  //                         className="credits_selected_container"
  //                         key={'detached-item'}
  //                       >
  //                         <div className="credits_channel_info">
  //                           <CustomInput
  //                             type="radio"
  //                             id={'detached-radio-item'}
  //                             value={'detached'}
  //                             onChange={field.onChange}
  //                             checked={field.value === 'detached'}
  //                           />
  //
  //                           <Icon
  //                             size={25}
  //                             icon="poli-icon pi-pay-line"
  //                             color={'var(--primary)'}
  //                           />
  //                           <div>
  //                             <Label for={'detached-radio-item'}>
  //                               Créditos adquiridos
  //                             </Label>
  //                           </div>
  //                         </div>
  //                         <div className="credits_selected">
  //                           <span>Saldo</span>
  //                           <p className="credits_selected_values">
  //                             <span
  //                               className={`credits_value ${
  //                                 credits.detached?.color
  //                                   ? `credits_value_${credits.detached?.color}`
  //                                   : ''
  //                               }`}
  //                             >
  //                               {credits?.detached.used}
  //                             </span>
  //                             {'/'}
  //                             <span>{credits?.detached.total}</span>
  //                           </p>
  //                         </div>
  //                       </li>
  //                     </Fragment>
  //                   )}
  //                 />
  //               </Fragment>
  //             )}
  //           </ul>
  //         </div>
  //         {/* Buy credits button */}
  //         {userIsAdminOrManager && !isWl && (
  //           <div className="credits_footer">
  //             <Button width="total" color="primary" onClick={handleBuyCredits}>
  //               Comprar crédito
  //             </Button>
  //           </div>
  //         )}
  //       </DropdownMenu>
  //     </Dropdown>
  //   </Fragment>
  // );
}
